import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { CmsContentService } from "../../../core/services/cms-content/cms-content.service";
import { ConfigService } from "../../../core/services/config.service";
import { NavBarService } from "../../../core/services/nav-bar/nav-bar.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
    selector: "app-cms-content",
    templateUrl: "./cms-content.component.html",
    styleUrls: ["./cms-content.component.scss"],
    providers: [CmsContentService],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CmsContentComponent implements OnInit {
  cmsPageContent: any;
  cmsPrivacyContent = "";
  cmsPrivacyContentPdf: any;
  cmsPdfImage = "";
  contentType = "";
  cmsImage = "";
  cmsTitle = "";
  cmsUserInfo: any;
  cmsGlobalData: any;
  cmsGlobalDataSchoolAdmins = ''; // receives the entire raw html from the api.
  cmsSchoolAdminsSection: SafeHtml = ''; // receives the processed html with placeholders replaced by actual values, ready for display in the template.

  constructor(
    private cmsContentService: CmsContentService,
    private router: Router,
    public configService: ConfigService,
    private navBarService: NavBarService,
    private sanitized: DomSanitizer
  ) { }

  ngOnInit() {
    const currentRoute = this.getCurrentRoutePath();
    this.contentType = currentRoute.slice(1);
    if (currentRoute.startsWith('/about-us')) {
      this.getContentByType(this.configService.aboutUs_Guid, 'page');
    }
    if (currentRoute.startsWith('/terms-of-use')) {
      window.location.href = this.configService.termsOfUse_content_link;
    }
    if (currentRoute.startsWith('/privacy-policies')) {
      console.log(this.configService.wPP_content_link);
      this.getContentByType(this.configService.privacyPolicy_Guid, 'page');
    }
    //Added below line for new contact-us
    if (currentRoute.startsWith('/contact-us')) {
      this.getuserInfo();
      this.getContentByType(this.configService.contactUs_Guid, 'page');
    }
  }
  getuserInfo() {
    return this.cmsContentService
      .getCustomerServiceInfo()
      .subscribe({
        next: (response) => {
          this.cmsUserInfo = response?.PrimaryData?.Attributes ?? null;
          this.ReplaceContent();
        },
        error: () => {
          this.cmsUserInfo = null;
          this.ReplaceContent();
        }
      });
  }
  ReplaceContent() {
    const phone = this.cmsUserInfo?.phoneNumber ?? '';
    const email = this.cmsUserInfo?.email ?? '';

    // Replace CMS placeholders and wrap section headings in <strong>.
    const replacePlaceholders = (html: string) =>
      (html ?? '')
        .replace(/\[csPhone\]/g, phone)
        .replace(/\[csEmail\]/g, email)
        .replace(/(<h[1-6][^>]*>)([^<]*Students[^<]*)(<\/h[1-6]>)/gi, '$1<strong>$2</strong>$3')
        .replace(/(<h[1-6][^>]*>)([^<]*School\s*Admins(?:\/Brokers)?[^<]*)(<\/h[1-6]>)/gi, '$1<strong>$2</strong>$3');

    this.cmsPageContent = this.sanitized.bypassSecurityTrustHtml(replacePlaceholders(this.cmsGlobalData));

    if (this.cmsGlobalDataSchoolAdmins) {
      this.cmsSchoolAdminsSection = this.sanitized.bypassSecurityTrustHtml(replacePlaceholders(this.cmsGlobalDataSchoolAdmins));
    } else {
      this.cmsSchoolAdminsSection = '';
    }
  }
  getContentByType(id: string, type: string) {
    this.cmsContentService
      .getUhcsrCmsContentByType(id, type)
      .subscribe((response) => {
        const currentRoute = this.getCurrentRoutePath();
        const payload = this.getCmsPayload(response);
        const regions = this.getCmsRegions(payload);
        const isPremiumCmsShape = Array.isArray(payload?.medias);
        const parallaxRegion = regions.find((r: any) => r?.Name === "ParallaxImage")
          ?? regions.find((r: any) => r?.Name === "TitleImage");
        const pageContentRegion = regions.find((r: any) => r?.Name === "PageContent")
          ?? regions.find((r: any) => r?.Name === "Body")
          ?? regions.find((r: any) => r?.Name === "text");
        const defaultBodyRegion = this.getDefaultBodyRegion(regions);

        this.cmsImage = this.buildMediaUrl(parallaxRegion?.Body?.Id, isPremiumCmsShape);
        this.cmsTitle = this.resolveTitle(regions, pageContentRegion, parallaxRegion);

        if (currentRoute.startsWith("/terms-of-use")) {
          const urls = JSON.parse(regions[0]?.Body?.Body ?? "{}");
          window.location.href = urls["TermsOfUseUrl"];
        }
        else {
          // tslint:disable-next-line: triple-equals
          if (currentRoute.startsWith("/privacy-policies")) {
            const pdfImageRegion = regions.find((r: any) => r?.Name === "PdfImage")
              ?? regions.find((r: any) => r?.Name === "pdf_Icon")
              ?? regions[2];
            const privacyContentRegion = regions.find((r: any) => r?.Name === "PrivacyContent")
              ?? regions.find((r: any) => r?.Name === "text")
              ?? regions[3]
              ?? pageContentRegion;

            this.cmsPdfImage = this.buildMediaUrl(pdfImageRegion?.Body?.Id, isPremiumCmsShape);
            this.cmsPrivacyContent = privacyContentRegion?.Body?.Body ?? "";

            let pdfArray = regions.length > 4 ? regions.slice(4) : [];
            // Filter content with no pdfs or urls
            pdfArray = pdfArray.filter(function (cmsContent) {
              return (
                cmsContent?.Body?.Body != null ||
                (cmsContent.Body[0] && cmsContent.Body[0].DisplayName)
              );
            });

            // tslint:disable-next-line: no-shadowed-variable
            pdfArray.forEach((element: any) => {
              if (element.Body.Title === 'Website Privacy Policy') {
                element.Body.Body = this.configService.wPP_content_link;
              }
            });

            this.cmsPrivacyContentPdf = pdfArray;
          }
          if (currentRoute.startsWith("/contact-us")) {
            // API region mapping (looked up by Name — order is not guaranteed):
            // "ParallaxImage" → Body.Id  (hero image)
            // "PageContent"   → Body.Title ("Contact Us"), Body.Body (Students HTML) — LEFT column
            // "BodyPart2"     → Body.Body (School Admins/Brokers HTML)              — RIGHT column
            const bodyPart2Region = regions.find((r: any) => r.Name === 'BodyPart2');

            // LEFT column — Students section
            let studentsHtml = pageContentRegion?.Body?.Body ?? '';
            studentsHtml = studentsHtml
              .replace(/href="got-a-question"/g,
                'href="https://www.uhcsr.com/got-a-question" target="_blank" rel="noopener"')
              .replace(/ui-sref="feedbackForm"/g,
                'href="https://www.uhcsr.com/got-a-question" target="_blank" rel="noopener"');

            // RIGHT column — School Admins/Brokers section
            let schoolAdminsHtml = bodyPart2Region?.Body?.Body ?? '';
            schoolAdminsHtml = schoolAdminsHtml
              .replace(/href="request-a-quote"/g,
                'href="https://www.uhcsr.com/request-a-quote" target="_blank" rel="noopener"')
              .replace(/ui-sref="requestQuote"/g,
                'href="https://www.uhcsr.com/request-a-quote" target="_blank" rel="noopener"');

            this.cmsGlobalData = studentsHtml;
            this.cmsGlobalDataSchoolAdmins = schoolAdminsHtml;
            this.ReplaceContent(); // replaces [csPhone]/[csEmail] placeholders and bolds headings
          }
          else {
            this.cmsPageContent = pageContentRegion?.Body?.Body ?? defaultBodyRegion?.Body?.Body ?? "";
          }
        }

        // this.navBarService.setTitleBarValue(this.cmsTitle);
      });
  }

  private getCurrentRoutePath(): string {
    const path = this.router.url.split('?')[0].split('#')[0];
    return path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
  }

  // Premium CMS returns media GUIDs served from its asset endpoint; legacy CMS ids resolve against the media CDN.
  private buildMediaUrl(mediaId: string | undefined, isPremiumCmsShape: boolean): string {
    if (!mediaId) {
      return "";
    }

    const baseUrl = isPremiumCmsShape
      ? (this.configService.cmsAssetURL ?? this.configService.cmsImageURL)
      : this.configService.cmsImageURL;

    if (!baseUrl) {
      return "";
    }

    return baseUrl.endsWith("/") ? baseUrl + mediaId : `${baseUrl}/${mediaId}`;
  }

  private getCmsRegions(response: any): any[] {
    if (Array.isArray(response?.Regions)) {
      return response.Regions;
    }

    return this.mapDirectCmsResponseToRegions(response);
  }

  // The CMS content can arrive raw or wrapped in PrimaryData.Attributes.cmsData as an object or JSON string.
  private getCmsPayload(response: any): any {
    const cmsData = response?.PrimaryData?.Attributes?.cmsData;

    if (!cmsData) {
      return response;
    }

    if (typeof cmsData !== "string") {
      return cmsData;
    }

    try {
      return JSON.parse(cmsData);
    } catch {
      return response;
    }
  }

  private resolveTitle(regions: any[], pageContentRegion: any, parallaxRegion: any): string {
    const candidates = [
      pageContentRegion?.Body?.Title,
      regions.find((r: any) => r?.Name === "PageTitle")?.Body?.Body,
      regions.find((r: any) => r?.Name === "PageTitle")?.Body?.Title,
      parallaxRegion?.Body?.Title,
      regions.find((r: any) => !!r?.Body?.Title?.trim?.())?.Body?.Title
    ];

    return candidates.find((title: any) => typeof title === "string" && title.trim().length > 0)?.trim() ?? "";
  }

  private mapDirectCmsResponseToRegions(response: any): any[] {
    const regions: any[] = [];

    if (Array.isArray(response?.medias)) {
      response.medias.forEach((media: any) => {
        regions.push({
          Name: media?.name,
          Body: {
            Id: media?.file,
            Title: media?.title ?? ""
          }
        });
      });
    }

    if (Array.isArray(response?.markdowns)) {
      response.markdowns.forEach((markdown: any) => {
        regions.push({
          Name: markdown?.name,
          Body: {
            Title: markdown?.title ?? "",
            Body: markdown?.markdown ?? ""
          }
        });
      });
    }

    return regions;
  }

  private getDefaultBodyRegion(regions: any[]): any {
    const preferredNames = ["Body", "PageContent", "text", "PrivacyContent", "BodyPart2"];
    const preferred = regions.find((r: any) => preferredNames.includes(r?.Name) && !!r?.Body?.Body?.trim?.());
    if (preferred) {
      return preferred;
    }

    return regions.find((r: any) => !!r?.Body?.Body?.trim?.());
  }
}
